import {
  GETAYURVEDICTYPE, CREATEAYURVEDICTYPE, UPDATEAYURVEDICTYPE, DELETEAYURVEDICTYPE,
  CREATEAYURVEDICPAINASSESSMENTSEVERITY,
  GETAYURVEDICPAINASSESSMENTSEVERITY,
  DELETEAYURVEDICPAINASSESSMENTSEVERITY,
  UPDATEAYURVEDICPAINASSESSMENTSEVERITY,
  CREATEAYURVEDICPAINASSESSMENTPAINNATURE,
  GETAYURVEDICPAINASSESSMENTPAINNATURE,
  DELETEAYURVEDICPAINASSESSMENTPAINNATURE,
  UPDATEAYURVEDICPAINASSESSMENTPAINNATURE,
  CREATEAYURVEDICPAINASSESSMENTPAINONSET,
  GETAYURVEDICPAINASSESSMENTPAINONSET,
  DELETEAYURVEDICPAINASSESSMENTPAINONSET,
  UPDATEAYURVEDICPAINASSESSMENTPAINONSET,
  CREATEAYURVEDICPAINASSESSMENTPAINVARIATION,
  GETAYURVEDICPAINASSESSMENTPAINVARIATION,
  DELETEAYURVEDICPAINASSESSMENTPAINVARIATION,
  UPDATEAYURVEDICPAINASSESSMENTPAINVARIATION,

  GETSETUPAYURVEDICHEALTHMAINT,
  CREATESETUPAYURVEDICHEALTHMAINT,
  UPDATESETUPAYURVEDICHEALTHMAINT,
  DELETESETUPAYURVEDICHEALTHMAINT,

  GETSETUPAYURVEDICRELATIONLST,
  CREATESETUPAYURVEDICRELATIONLST,
  UPDATESETUPAYURVEDICRELATIONLST,
  DELETESETUPAYURVEDICRELATIONLST,

  GETSETUPAYURVEDICPERSONALHISTORY,
  CREATESETUPAYURVEDICPERSONALHISTORY,
  UPDATESETUPAYURVEDICPERSONALHISTORY,
  DELETESETUPAYURVEDICPERSONALHISTORY,

  GETSETUPAYURVEDICDIGESTIVETRACT,
  CREATESETUPAYURVEDICDIGESTIVETRACT,
  UPDATESETUPAYURVEDICDIGESTIVETRACT,
  DELETESETUPAYURVEDICDIGESTIVETRACT,

  GETSETUPAYURVEDICBOWEL,
  CREATESETUPAYURVEDICBOWEL,
  UPDATESETUPAYURVEDICBOWEL,
  DELETESETUPAYURVEDICBOWEL,

  GETSETUPAYURVEDICSLEEP,
  CREATESETUPAYURVEDICSLEEP,
  UPDATESETUPAYURVEDICSLEEP,
  DELETESETUPAYURVEDICSLEEP,

  GETSETUPAYURVEDICADDICTIONS,
  CREATESETUPAYURVEDICADDICTIONS,
  UPDATESETUPAYURVEDICADDICTIONS,
  DELETESETUPAYURVEDICADDICTIONS,

  GETSETUPAYURVEDICHIGHRISK,
  CREATESETUPAYURVEDICHIGHRISK,
  UPDATESETUPAYURVEDICHIGHRISK,
  DELETESETUPAYURVEDICHIGHRISK,

  GETSETUPAYURVEDICPOSITIONOFWORK,
  CREATESETUPAYURVEDICPOSITIONOFWORK,
  UPDATESETUPAYURVEDICPOSITIONOFWORK,
  DELETESETUPAYURVEDICPOSITIONOFWORK,

  GETSETUPAYURVEDICNATUREOFWORK,
  CREATESETUPAYURVEDICNATUREOFWORK,
  UPDATESETUPAYURVEDICNATUREOFWORK,
  DELETESETUPAYURVEDICNATUREOFWORK,

  GETSETUPAYURVEDICDEPRESSION,
  CREATESETUPAYURVEDICDEPRESSION,
  UPDATESETUPAYURVEDICDEPRESSION,
  DELETESETUPAYURVEDICDEPRESSION,

  GETSETUPAYURVEDICIRRITABILITY,
  CREATESETUPAYURVEDICIRRITABILITY,
  UPDATESETUPAYURVEDICIRRITABILITY,
  DELETESETUPAYURVEDICIRRITABILITY,

  GETSETUPAYURVEDICEUPHORIA,
  CREATESETUPAYURVEDICEUPHORIA,
  UPDATESETUPAYURVEDICEUPHORIA,
  DELETESETUPAYURVEDICEUPHORIA,

  GETSETUPAYURVEDICOBSESSION,
  CREATESETUPAYURVEDICOBSESSION,
  UPDATESETUPAYURVEDICOBSESSION,
  DELETESETUPAYURVEDICOBSESSION,

  GETSETUPAYURVEDICNEUROSIS,
  CREATESETUPAYURVEDICNEUROSIS,
  UPDATESETUPAYURVEDICNEUROSIS,
  DELETESETUPAYURVEDICNEUROSIS,

  GETSETUPAYURVEDICDEPERSONALIZATION,
  CREATESETUPAYURVEDICDEPERSONALIZATION,
  UPDATESETUPAYURVEDICDEPERSONALIZATION,
  DELETESETUPAYURVEDICDEPERSONALIZATION,

  GETSETUPAYURVEDICALLOPATHICMEDI,
  CREATESETUPAYURVEDICALLOPATHICMEDI,
  UPDATESETUPAYURVEDICALLOPATHICMEDI,
  DELETESETUPAYURVEDICALLOPATHICMEDI,

  GETSETUPAYURVEDICAYURVEDAMEDI,
  CREATESETUPAYURVEDICAYURVEDAMEDI,
  UPDATESETUPAYURVEDICAYURVEDAMEDI,
  DELETESETUPAYURVEDICAYURVEDAMEDI,

  GETSETUPAYURVEDICHOMEOPATHYMEDI,
  CREATESETUPAYURVEDICHOMEOPATHYMEDI,
  UPDATESETUPAYURVEDICHOMEOPATHYMEDI,
  DELETESETUPAYURVEDICHOMEOPATHYMEDI,

  GETSETUPAYURVEDICOTHERMEDI,
  CREATESETUPAYURVEDICOTHERMEDI,
  UPDATESETUPAYURVEDICOTHERMEDI,
  DELETESETUPAYURVEDICOTHERMEDI,

  GETSETUPAYURVEDICPSYCOLOGICALHIST,
  CREATESETUPAYURVEDICPSYCOLOGICALHIST,
  UPDATESETUPAYURVEDICPSYCOLOGICALHIST,
  DELETESETUPAYURVEDICPSYCOLOGICALHIST,

  GETSETUPAYURVEDICGYNECOLOGICAL,
  CREATESETUPAYURVEDICGYNECOLOGICAL,
  UPDATESETUPAYURVEDICGYNECOLOGICAL,
  DELETESETUPAYURVEDICGYNECOLOGICAL,

  GETSETUPAYURVEDICOBSTETRICALHIST,
  CREATESETUPAYURVEDICOBSTETRICALHIST,
  UPDATESETUPAYURVEDICOBSTETRICALHIST,
  DELETESETUPAYURVEDICOBSTETRICALHIST,

  GETSETUPAYURVEDICEXAMINATIONGENERALAPPEARANCE,
  CREATESETUPAYURVEDICEXAMINATIONGENERALAPPEARANCE,
  UPDATESETUPAYURVEDICEXAMINATIONGENERALAPPEARANCE,
  DELETESETUPAYURVEDICEXAMINATIONGENERALAPPEARANCE,

  GETSETUPAYURVEDICEXAMINATIONNUTRITION,
  CREATESETUPAYURVEDICEXAMINATIONNUTRITION,
  UPDATESETUPAYURVEDICEXAMINATIONNUTRITION,
  DELETESETUPAYURVEDICEXAMINATIONNUTRITION,

  GETSETUPAYURVEDICEXAMINATIONANAEMIA,
  CREATESETUPAYURVEDICEXAMINATIONANAEMIA,
  UPDATESETUPAYURVEDICEXAMINATIONANAEMIA,
  DELETESETUPAYURVEDICEXAMINATIONANAEMIA,

  GETSETUPAYURVEDICEXAMINATIONNECKVEIN,
  CREATESETUPAYURVEDICEXAMINATIONNECKVEIN,
  UPDATESETUPAYURVEDICEXAMINATIONNECKVEIN,
  DELETESETUPAYURVEDICEXAMINATIONNECKVEIN,

  GETSETUPAYURVEDICEXAMINATIONLYMPHNODES,
  CREATESETUPAYURVEDICEXAMINATIONLYMPHNODES,
  UPDATESETUPAYURVEDICEXAMINATIONLYMPHNODES,
  DELETESETUPAYURVEDICEXAMINATIONLYMPHNODES,

  GETSETUPAYURVEDICEXAMINATIONBUILD,
  CREATESETUPAYURVEDICEXAMINATIONBUILD,
  UPDATESETUPAYURVEDICEXAMINATIONBUILD,
  DELETESETUPAYURVEDICEXAMINATIONBUILD,

  GETSETUPAYURVEDICEXAMINATIONPULSE,
  CREATESETUPAYURVEDICEXAMINATIONPULSE,
  UPDATESETUPAYURVEDICEXAMINATIONPULSE,
  DELETESETUPAYURVEDICEXAMINATIONPULSE,

  GETSETUPAYURVEDICEXAMINATIONTONGUE,
  CREATESETUPAYURVEDICEXAMINATIONTONGUE,
  UPDATESETUPAYURVEDICEXAMINATIONTONGUE,
  DELETESETUPAYURVEDICEXAMINATIONTONGUE,

  GETSETUPAYURVEDICEXAMINATIONPOOP,
  CREATESETUPAYURVEDICEXAMINATIONPOOP,
  UPDATESETUPAYURVEDICEXAMINATIONPOOP,
  DELETESETUPAYURVEDICEXAMINATIONPOOP,

  GETSETUPAYURVEDICEXAMINATIONURINE,
  CREATESETUPAYURVEDICEXAMINATIONURINE,
  UPDATESETUPAYURVEDICEXAMINATIONURINE,
  DELETESETUPAYURVEDICEXAMINATIONURINE,

  GETSETUPAYURVEDICEXAMINATIONWORD,
  CREATESETUPAYURVEDICEXAMINATIONWORD,
  UPDATESETUPAYURVEDICEXAMINATIONWORD,
  DELETESETUPAYURVEDICEXAMINATIONWORD,

  GETSETUPAYURVEDICEXAMINATIONTOUCH,
  CREATESETUPAYURVEDICEXAMINATIONTOUCH,
  UPDATESETUPAYURVEDICEXAMINATIONTOUCH,
  DELETESETUPAYURVEDICEXAMINATIONTOUCH,

  GETSETUPAYURVEDICEXAMINATIONEYE,
  CREATESETUPAYURVEDICEXAMINATIONEYE,
  UPDATESETUPAYURVEDICEXAMINATIONEYE,
  DELETESETUPAYURVEDICEXAMINATIONEYE,

  GETSETUPAYURVEDICEXAMINATIONAKRITA,
  CREATESETUPAYURVEDICEXAMINATIONAKRITA,
  UPDATESETUPAYURVEDICEXAMINATIONAKRITA,
  DELETESETUPAYURVEDICEXAMINATIONAKRITA,

  GETSETUPAYURVEDICEXAMINATIONNATUREPHYSICAL,
  CREATESETUPAYURVEDICEXAMINATIONNATUREPHYSICAL,
  UPDATESETUPAYURVEDICEXAMINATIONNATUREPHYSICAL,
  DELETESETUPAYURVEDICEXAMINATIONNATUREPHYSICAL,

  GETSETUPAYURVEDICEXAMINATIONNATUREMENTAL,
  CREATESETUPAYURVEDICEXAMINATIONNATUREMENTAL,
  UPDATESETUPAYURVEDICEXAMINATIONNATUREMENTAL,
  DELETESETUPAYURVEDICEXAMINATIONNATUREMENTAL,

  GETSETUPAYURVEDICEXAMINATIONSUBSTANCE,
  CREATESETUPAYURVEDICEXAMINATIONSUBSTANCE,
  UPDATESETUPAYURVEDICEXAMINATIONSUBSTANCE,
  DELETESETUPAYURVEDICEXAMINATIONSUBSTANCE,

  GETSETUPAYURVEDICEXAMINATIONCOMPACTION,
  CREATESETUPAYURVEDICEXAMINATIONCOMPACTION,
  UPDATESETUPAYURVEDICEXAMINATIONCOMPACTION,
  DELETESETUPAYURVEDICEXAMINATIONCOMPACTION,

  GETSETUPAYURVEDICEXAMINATIONPERCEPTION,
  CREATESETUPAYURVEDICEXAMINATIONPERCEPTION,
  UPDATESETUPAYURVEDICEXAMINATIONPERCEPTION,
  DELETESETUPAYURVEDICEXAMINATIONPERCEPTION,

  GETSETUPAYURVEDICEXAMINATIONSUITABILITY,
  CREATESETUPAYURVEDICEXAMINATIONSUITABILITY,
  UPDATESETUPAYURVEDICEXAMINATIONSUITABILITY,
  DELETESETUPAYURVEDICEXAMINATIONSUITABILITY,

  GETSETUPAYURVEDICEXAMINATIONSUBSTANCESVATVAM,
  CREATESETUPAYURVEDICEXAMINATIONSUBSTANCESVATVAM,
  UPDATESETUPAYURVEDICEXAMINATIONSUBSTANCESVATVAM,
  DELETESETUPAYURVEDICEXAMINATIONSUBSTANCESVATVAM,

  GETSETUPAYURVEDICEXAMINATIONDIETCARRYPOWER,
  CREATESETUPAYURVEDICEXAMINATIONDIETCARRYPOWER,
  UPDATESETUPAYURVEDICEXAMINATIONDIETCARRYPOWER,
  DELETESETUPAYURVEDICEXAMINATIONDIETCARRYPOWER,

  GETSETUPAYURVEDICEXAMINATIONDIETBURNINGPOWER,
  CREATESETUPAYURVEDICEXAMINATIONDIETBURNINGPOWER,
  UPDATESETUPAYURVEDICEXAMINATIONDIETBURNINGPOWER,
  DELETESETUPAYURVEDICEXAMINATIONDIETBURNINGPOWER,

  GETSETUPAYURVEDICEXAMINATIONEXERCIZEPOWER,
  CREATESETUPAYURVEDICEXAMINATIONEXERCIZEPOWER,
  UPDATESETUPAYURVEDICEXAMINATIONEXERCIZEPOWER,
  DELETESETUPAYURVEDICEXAMINATIONEXERCIZEPOWER,

  GETSETUPAYURVEDICEXAMINATIONAGE,
  CREATESETUPAYURVEDICEXAMINATIONAGE,
  UPDATESETUPAYURVEDICEXAMINATIONAGE,
  DELETESETUPAYURVEDICEXAMINATIONAGE,

  GETSETUPAYURVEDICEXAMINATIONPRANAVAHSROTAS,
  CREATESETUPAYURVEDICEXAMINATIONPRANAVAHSROTAS,
  UPDATESETUPAYURVEDICEXAMINATIONPRANAVAHSROTAS,
  DELETESETUPAYURVEDICEXAMINATIONPRANAVAHSROTAS,

  GETSETUPAYURVEDICEXAMINATIONANNAVAHSROTAS,
  CREATESETUPAYURVEDICEXAMINATIONANNAVAHSROTAS,
  UPDATESETUPAYURVEDICEXAMINATIONANNAVAHSROTAS,
  DELETESETUPAYURVEDICEXAMINATIONANNAVAHSROTAS,

  GETSETUPAYURVEDICEXAMINATIONUDAKAVAHASROTAS,
  CREATESETUPAYURVEDICEXAMINATIONUDAKAVAHASROTAS,
  UPDATESETUPAYURVEDICEXAMINATIONUDAKAVAHASROTAS,
  DELETESETUPAYURVEDICEXAMINATIONUDAKAVAHASROTAS,

  GETSETUPAYURVEDICEXAMINATIONRASAVAHASROTAS,
  CREATESETUPAYURVEDICEXAMINATIONRASAVAHASROTAS,
  UPDATESETUPAYURVEDICEXAMINATIONRASAVAHASROTAS,
  DELETESETUPAYURVEDICEXAMINATIONRASAVAHASROTAS,

  GETSETUPAYURVEDICEXAMINATIONRAKTAVAHASROTAS,
  CREATESETUPAYURVEDICEXAMINATIONRAKTAVAHASROTAS,
  UPDATESETUPAYURVEDICEXAMINATIONRAKTAVAHASROTAS,
  DELETESETUPAYURVEDICEXAMINATIONRAKTAVAHASROTAS,

  GETSETUPAYURVEDICEXAMINATIONMAMSAVAHASROTAS,
  CREATESETUPAYURVEDICEXAMINATIONMAMSAVAHASROTAS,
  UPDATESETUPAYURVEDICEXAMINATIONMAMSAVAHASROTAS,
  DELETESETUPAYURVEDICEXAMINATIONMAMSAVAHASROTAS,

  GETSETUPAYURVEDICEXAMINATIONMEDOVAHASROTAS,
  CREATESETUPAYURVEDICEXAMINATIONMEDOVAHASROTAS,
  UPDATESETUPAYURVEDICEXAMINATIONMEDOVAHASROTAS,
  DELETESETUPAYURVEDICEXAMINATIONMEDOVAHASROTAS,

  GETSETUPAYURVEDICEXAMINATIONASTHIVAHASROTAS,
  CREATESETUPAYURVEDICEXAMINATIONASTHIVAHASROTAS,
  UPDATESETUPAYURVEDICEXAMINATIONASTHIVAHASROTAS,
  DELETESETUPAYURVEDICEXAMINATIONASTHIVAHASROTAS,

  GETSETUPAYURVEDICEXAMINATIONMAJJAVHASROTAS,
  CREATESETUPAYURVEDICEXAMINATIONMAJJAVHASROTAS,
  UPDATESETUPAYURVEDICEXAMINATIONMAJJAVHASROTAS,
  DELETESETUPAYURVEDICEXAMINATIONMAJJAVHASROTAS,

  GETSETUPAYURVEDICEXAMINATIONSUKRAVAHASROTAS,
  CREATESETUPAYURVEDICEXAMINATIONSUKRAVAHASROTAS,
  UPDATESETUPAYURVEDICEXAMINATIONSUKRAVAHASROTAS,
  DELETESETUPAYURVEDICEXAMINATIONSUKRAVAHASROTAS,

  GETSETUPAYURVEDICEXAMINATIONMOOTRAVAHASROTAS,
  CREATESETUPAYURVEDICEXAMINATIONMOOTRAVAHASROTAS,
  UPDATESETUPAYURVEDICEXAMINATIONMOOTRAVAHASROTAS,
  DELETESETUPAYURVEDICEXAMINATIONMOOTRAVAHASROTAS,

  GETSETUPAYURVEDICEXAMINATIONPUREESHVAHASROTAS,
  CREATESETUPAYURVEDICEXAMINATIONPUREESHVAHASROTAS,
  UPDATESETUPAYURVEDICEXAMINATIONPUREESHVAHASROTAS,
  DELETESETUPAYURVEDICEXAMINATIONPUREESHVAHASROTAS,

  GETSETUPAYURVEDICEXAMINATIONSWEDAVAHASROTAS,
  CREATESETUPAYURVEDICEXAMINATIONSWEDAVAHASROTAS,
  UPDATESETUPAYURVEDICEXAMINATIONSWEDAVAHASROTAS,
  DELETESETUPAYURVEDICEXAMINATIONSWEDAVAHASROTAS,

  GETSETUPAYURVEDICEXAMINATIONTHEFAULT,
  CREATESETUPAYURVEDICEXAMINATIONTHEFAULT,
  UPDATESETUPAYURVEDICEXAMINATIONTHEFAULT,
  DELETESETUPAYURVEDICEXAMINATIONTHEFAULT,

  GETSETUPAYURVEDICEXAMINATIONDUSHYA,
  CREATESETUPAYURVEDICEXAMINATIONDUSHYA,
  UPDATESETUPAYURVEDICEXAMINATIONDUSHYA,
  DELETESETUPAYURVEDICEXAMINATIONDUSHYA,

  GETSETUPAYURVEDICEXAMINATIONFIRE,
  CREATESETUPAYURVEDICEXAMINATIONFIRE,
  UPDATESETUPAYURVEDICEXAMINATIONFIRE,
  DELETESETUPAYURVEDICEXAMINATIONFIRE,

  GETSETUPAYURVEDICEXAMINATIONAMA,
  CREATESETUPAYURVEDICEXAMINATIONAMA,
  UPDATESETUPAYURVEDICEXAMINATIONAMA,
  DELETESETUPAYURVEDICEXAMINATIONAMA,

  GETSETUPAYURVEDICEXAMINATIONSOURCES,
  CREATESETUPAYURVEDICEXAMINATIONSOURCES,
  UPDATESETUPAYURVEDICEXAMINATIONSOURCES,
  DELETESETUPAYURVEDICEXAMINATIONSOURCES,

  GETSETUPAYURVEDICEXAMINATIONFACULTYSOURCESTYPE,
  CREATESETUPAYURVEDICEXAMINATIONFACULTYSOURCESTYPE,
  UPDATESETUPAYURVEDICEXAMINATIONFACULTYSOURCESTYPE,
  DELETESETUPAYURVEDICEXAMINATIONFACULTYSOURCESTYPE,

  GETSETUPAYURVEDICEXAMINATIONPLACEOFORIGIN,
  CREATESETUPAYURVEDICEXAMINATIONPLACEOFORIGIN,
  UPDATESETUPAYURVEDICEXAMINATIONPLACEOFORIGIN,
  DELETESETUPAYURVEDICEXAMINATIONPLACEOFORIGIN,

  GETAYURVEDICOPDCHILDHOODILLNESS,
  CREATEAYURVVEDICOPDCHILDHOODILLNESS,
  UPDATEAYURVEDICOPDCHILDHOODILLNESS,
  DELETEAYURVEDICOPDCHILDHOODILLNESS,

  GETAYURVEDICOPDADULTILLNESS,
  CREATEAYURVVEDICOPDADULTILLNESS,
  UPDATEAYURVEDICOPDADULTILLNESS,
  DELETEAYURVEDICOPDADULTILLNESS,
} from '../actions/types';

const initialState = {
  ayurvedicList: [],
  ayurvedicSaveStatus: null,
  editStatus: null,
};

export default function setupayurvedicReducer(state = initialState, action) {
  switch (action.type) {
    case GETAYURVEDICTYPE:
      return {
        ...state,
        ayurvedicList: action.payload.data,
      };
    case CREATEAYURVEDICTYPE:
      return {
        ...state,
        ayurvedicSaveStatus: action.payload.success,
      };
    case UPDATEAYURVEDICTYPE:
      return {
        ...state,
        ayurvedicList: state.ayurvedicList.map(item =>
          item.id === action.payload.data.id ? action.payload.data : item
        ),
        editStatus: action.payload.success,
      };
    case DELETEAYURVEDICTYPE:
      return {
        ...state,
        ayurvedicList: state.ayurvedicList.filter(item => item.id !== action.payload.data.id),
        ayurvedicDeleteStatus: action.payload.success,
      };

    case CREATEAYURVEDICPAINASSESSMENTSEVERITY:
      return {
        ...state,
        ayurvedicpainassesmentstatusSaveStatus: action.payload.success,
      }
    case GETAYURVEDICPAINASSESSMENTSEVERITY:
      return {
        ...state,
        ayurvedicpainassesmentseverityList: action.payload.data,
      }
    case UPDATEAYURVEDICPAINASSESSMENTSEVERITY:
      return {
        ...state,
        ayurvedicpainassesmentseverityUpdateStatus: action.payload.success,
      }

    case DELETEAYURVEDICPAINASSESSMENTSEVERITY:
      return {
        ...state,
        ayurvedicpainassesmentseverityDeleteStatus: action.payload.success,
      }
    case CREATEAYURVEDICPAINASSESSMENTPAINNATURE:
      return {
        ...state,
        ayurvedicpainassesmentpainnatureSaveStatus: action.payload.success,
      }
    case GETAYURVEDICPAINASSESSMENTPAINNATURE:
      return {
        ...state,
        ayurvedicpainassesmentpainnatureList: action.payload.data,
      }
    case UPDATEAYURVEDICPAINASSESSMENTPAINNATURE:
      return {
        ...state,
        ayurvedicpainassesmentpainnatureUpdateStatus: action.payload.success,
      }

    case DELETEAYURVEDICPAINASSESSMENTPAINNATURE:
      return {
        ...state,
        ayurvedicpainassesmentpainnatureDeleteStatus: action.payload.success,
      }

    case CREATEAYURVEDICPAINASSESSMENTPAINONSET:
      return {
        ...state,
        ayurvedicpainassesmentpainonsetSaveStatus: action.payload.success,
      }
    case GETAYURVEDICPAINASSESSMENTPAINONSET:
      return {
        ...state,
        ayurvedicpainassesmentpainonsetList: action.payload.data,
      }
    case UPDATEAYURVEDICPAINASSESSMENTPAINONSET:
      return {
        ...state,
        ayurvedicpainassesmentpainonsetUpdateStatus: action.payload.success,
      }

    case DELETEAYURVEDICPAINASSESSMENTPAINONSET:
      return {
        ...state,
        ayurvedicpainassesmentpainonsetDeleteStatus: action.payload.success,
      }
    case CREATEAYURVEDICPAINASSESSMENTPAINVARIATION:
      return {
        ...state,
        ayurvedicpainassesmentpainvariationSaveStatus: action.payload.success,
      }
    case GETAYURVEDICPAINASSESSMENTPAINVARIATION:
      return {
        ...state,
        ayurvedicpainassesmentpainvariationList: action.payload.data,
      }
    case UPDATEAYURVEDICPAINASSESSMENTPAINVARIATION:
      return {
        ...state,
        ayurvedicpainassesmentpainvariationUpdateStatus: action.payload.success,
      }

    case DELETEAYURVEDICPAINASSESSMENTPAINVARIATION:
      return {
        ...state,
        ayurvedicpainassesmentpainvariationDeleteStatus: action.payload.success,
      }

    case CREATESETUPAYURVEDICHEALTHMAINT:
      return {
        ...state,
        ayurvedicsetuphealthmaintSaveStatus: action.payload.success,
      }
    case GETSETUPAYURVEDICHEALTHMAINT:
      return {
        ...state,
        ayurvedicsetuphealthmaintList: action.payload.data,
      }
    case UPDATESETUPAYURVEDICHEALTHMAINT:
      return {
        ...state,
        ayurvedicsetuphealthmaintUpdateStatus: action.payload.success,
      }

    case DELETESETUPAYURVEDICHEALTHMAINT:
      return {
        ...state,
        ayurvedicsetuphealthmaintDeleteStatus: action.payload.success,
      }

    case CREATESETUPAYURVEDICRELATIONLST:
      return {
        ...state,
        ayurvedicsetuprelationSaveStatus: action.payload.success,
      }
    case GETSETUPAYURVEDICRELATIONLST:
      return {
        ...state,
        ayurvedicsetuprelationList: action.payload.data,
      }
    case UPDATESETUPAYURVEDICRELATIONLST:
      return {
        ...state,
        ayurvedicsetuprelationUpdateStatus: action.payload.success,
      }

    case DELETESETUPAYURVEDICRELATIONLST:
      return {
        ...state,
        ayurvedicsetuprelationDeleteStatus: action.payload.success,
      }

    case CREATESETUPAYURVEDICPERSONALHISTORY:
      return {
        ...state,
        ayurvedicsetuppersonalhistorySaveStatus: action.payload.success,
      }
    case GETSETUPAYURVEDICPERSONALHISTORY:
      return {
        ...state,
        ayurvedicsetuppersonalhistoryList: action.payload.data,
      }
    case UPDATESETUPAYURVEDICPERSONALHISTORY:
      return {
        ...state,
        ayurvedicsetuppersonalhistoryUpdateStatus: action.payload.success,
      }

    case DELETESETUPAYURVEDICPERSONALHISTORY:
      return {
        ...state,
        ayurvedicsetuppersonalhistoryDeleteStatus: action.payload.success,
      }

    case CREATESETUPAYURVEDICALLOPATHICMEDI:
      return {
        ...state,
        ayurvedicsetupallopathicSaveStatus: action.payload.success,
      }
    case GETSETUPAYURVEDICALLOPATHICMEDI:
      return {
        ...state,
        ayurvedicsetupallopathicList: action.payload.data,
      }
    case UPDATESETUPAYURVEDICALLOPATHICMEDI:
      return {
        ...state,
        ayurvedicsetupallopathicUpdateStatus: action.payload.success,
      }

    case DELETESETUPAYURVEDICALLOPATHICMEDI:
      return {
        ...state,
        ayurvedicsetupallopathicDeleteStatus: action.payload.success,
      }

    case CREATESETUPAYURVEDICAYURVEDAMEDI:
      return {
        ...state,
        ayurvedicsetupayurvedaSaveStatus: action.payload.success,
      }
    case GETSETUPAYURVEDICAYURVEDAMEDI:
      return {
        ...state,
        ayurvedicsetupayurvedaList: action.payload.data,
      }
    case UPDATESETUPAYURVEDICAYURVEDAMEDI:
      return {
        ...state,
        ayurvedicsetupayurvedaUpdateStatus: action.payload.success,
      }

    case DELETESETUPAYURVEDICAYURVEDAMEDI:
      return {
        ...state,
        ayurvedicsetupayurvedaDeleteStatus: action.payload.success,
      }
    case CREATESETUPAYURVEDICHOMEOPATHYMEDI:
      return {
        ...state,
        ayurvedicsetuphomeopathySaveStatus: action.payload.success,
      }
    case GETSETUPAYURVEDICHOMEOPATHYMEDI:
      return {
        ...state,
        ayurvedicsetuphomeopathyList: action.payload.data,
      }
    case UPDATESETUPAYURVEDICHOMEOPATHYMEDI:
      return {
        ...state,
        ayurvedicsetuphomeopathyUpdateStatus: action.payload.success,
      }

    case DELETESETUPAYURVEDICHOMEOPATHYMEDI:
      return {
        ...state,
        ayurvedicsetuphomeopathyDeleteStatus: action.payload.success,
      }

    case CREATESETUPAYURVEDICOTHERMEDI:
      return {
        ...state,
        ayurvedicsetupOtherRSaveStatus: action.payload.success,
      }
    case GETSETUPAYURVEDICOTHERMEDI:
      return {
        ...state,
        ayurvedicsetupOtherList: action.payload.data,
      }
    case UPDATESETUPAYURVEDICOTHERMEDI:
      return {
        ...state,
        ayurvedicsetupOtherUpdateStatus: action.payload.success,
      }

    case DELETESETUPAYURVEDICOTHERMEDI:
      return {
        ...state,
        ayurvedicsetupOtherDeleteStatus: action.payload.success,
      }


    case CREATESETUPAYURVEDICPSYCOLOGICALHIST:
      return {
        ...state,
        ayurvedicsetupPsycologicalHistSaveStatus: action.payload.success,
      }
    case GETSETUPAYURVEDICPSYCOLOGICALHIST:
      return {
        ...state,
        ayurvedicsetupPsycologicalHistList: action.payload.data,
      }
    case UPDATESETUPAYURVEDICPSYCOLOGICALHIST:
      return {
        ...state,
        ayurvedicsetupPsycologicalHistUpdateStatus: action.payload.success,
      }

    case DELETESETUPAYURVEDICPSYCOLOGICALHIST:
      return {
        ...state,
        ayurvedicsetupPsycologicalHistDeleteStatus: action.payload.success,
      }

    case CREATESETUPAYURVEDICGYNECOLOGICAL:
      return {
        ...state,
        ayurvedicsetupGynecologicalHistSaveStatus: action.payload.success,
      }
    case GETSETUPAYURVEDICGYNECOLOGICAL:
      return {
        ...state,
        ayurvedicsetupGynecologicalHistList: action.payload.data,
      }
    case UPDATESETUPAYURVEDICGYNECOLOGICAL:
      return {
        ...state,
        ayurvedicsetupGynecologicalHistUpdateStatus: action.payload.success,
      }

    case DELETESETUPAYURVEDICGYNECOLOGICAL:
      return {
        ...state,
        ayurvedicsetupGynecologicalHistDeleteStatus: action.payload.success,
      }

    case CREATESETUPAYURVEDICOBSTETRICALHIST:
      return {
        ...state,
        ayurvedicsetupObstetricalHistSaveStatus: action.payload.success,
      }
    case GETSETUPAYURVEDICOBSTETRICALHIST:
      return {
        ...state,
        ayurvedicsetupObstetricalHistList: action.payload.data,
      }
    case UPDATESETUPAYURVEDICOBSTETRICALHIST:
      return {
        ...state,
        ayurvedicsetupObstetricalHistUpdateStatus: action.payload.success,
      }

    case DELETESETUPAYURVEDICOBSTETRICALHIST:
      return {
        ...state,
        ayurvedicsetupObstetricalHistDeleteStatus: action.payload.success,
      }

    case CREATESETUPAYURVEDICEXAMINATIONGENERALAPPEARANCE:
      return {
        ...state,
        ayurvedicsetupGeneralApperanceSaveStatus: action.payload.success,
      }
    case GETSETUPAYURVEDICEXAMINATIONGENERALAPPEARANCE:
      return {
        ...state,
        ayurvedicsetupGeneralApperanceList: action.payload.data,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONGENERALAPPEARANCE:
      return {
        ...state,
        ayurvedicsetupGeneralApperanceUpdateStatus: action.payload.success,
      }

    case DELETESETUPAYURVEDICEXAMINATIONGENERALAPPEARANCE:
      return {
        ...state,
        ayurvedicsetupGeneralApperanceDeleteStatus: action.payload.success,
      }


    case CREATESETUPAYURVEDICEXAMINATIONNUTRITION:
      return {
        ...state,
        ayurvedicsetupNutritionsSaveStatus: action.payload.success,
      }
    case GETSETUPAYURVEDICEXAMINATIONNUTRITION:
      return {
        ...state,
        ayurvedicsetupNutritionsList: action.payload.data,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONNUTRITION:
      return {
        ...state,
        ayurvedicsetupNutritionsUpdateStatus: action.payload.success,
      }

    case DELETESETUPAYURVEDICEXAMINATIONNUTRITION:
      return {
        ...state,
        ayurvedicsetupNutritionsDeleteStatus: action.payload.success,
      }


    case CREATESETUPAYURVEDICEXAMINATIONANAEMIA:
      return {
        ...state,
        ayurvedicsetupAnaemiaSaveStatus: action.payload.success,
      }
    case GETSETUPAYURVEDICEXAMINATIONANAEMIA:
      return {
        ...state,
        ayurvedicsetupAnaemiaList: action.payload.data,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONANAEMIA:
      return {
        ...state,
        ayurvedicsetupAnaemiaUpdateStatus: action.payload.success,
      }

    case DELETESETUPAYURVEDICEXAMINATIONANAEMIA:
      return {
        ...state,
        ayurvedicsetupAnaemiaDeleteStatus: action.payload.success,
      }


    case CREATESETUPAYURVEDICEXAMINATIONNECKVEIN:
      return {
        ...state,
        ayurvedicsetupNeckVeinSaveStatus: action.payload.success,
      }
    case GETSETUPAYURVEDICEXAMINATIONNECKVEIN:
      return {
        ...state,
        ayurvedicsetupNeckVeinList: action.payload.data,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONNECKVEIN:
      return {
        ...state,
        ayurvedicsetupNeckVeinUpdateStatus: action.payload.success,
      }

    case DELETESETUPAYURVEDICEXAMINATIONNECKVEIN:
      return {
        ...state,
        ayurvedicsetupNeckVeinDeleteStatus: action.payload.success,
      }


    case CREATESETUPAYURVEDICEXAMINATIONLYMPHNODES:
      return {
        ...state,
        ayurvedicsetupLymphnodesSaveStatus: action.payload.success,
      }
    case GETSETUPAYURVEDICEXAMINATIONLYMPHNODES:
      return {
        ...state,
        ayurvedicsetupLymphnodesList: action.payload.data,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONLYMPHNODES:
      return {
        ...state,
        ayurvedicsetupLymphnodesUpdateStatus: action.payload.success,
      }

    case DELETESETUPAYURVEDICEXAMINATIONLYMPHNODES:
      return {
        ...state,
        ayurvedicsetupLymphnodesDeleteStatus: action.payload.success,
      }

    case CREATESETUPAYURVEDICEXAMINATIONBUILD:
      return {
        ...state,
        ayurvedicsetupBuildSaveStatus: action.payload.success,
      }
    case GETSETUPAYURVEDICEXAMINATIONBUILD:
      return {
        ...state,
        ayurvedicsetupBuildList: action.payload.data,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONBUILD:
      return {
        ...state,
        ayurvedicsetupBuildUpdateStatus: action.payload.success,
      }

    case DELETESETUPAYURVEDICEXAMINATIONBUILD:
      return {
        ...state,
        ayurvedicsetupBuildDeleteStatus: action.payload.success,
      }


    case GETSETUPAYURVEDICEXAMINATIONPULSE:
      return {
        ...state,
        ayurvedicsetupPulseList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEXAMINATIONPULSE:
      return {
        ...state,
        ayurvedicsetupPulseSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONPULSE:
      return {
        ...state,
        ayurvedicsetupPulseUpdateStatus: action.payload.success,
      }

    case DELETESETUPAYURVEDICEXAMINATIONPULSE:
      return {
        ...state,
        ayurvedicsetupPulseDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICEXAMINATIONTONGUE:
      return {
        ...state,
        ayurvedicsetupTongueList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEXAMINATIONTONGUE:
      return {
        ...state,
        ayurvedicsetupTongueSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONTONGUE:
      return {
        ...state,
        ayurvedicsetupTongueUpdateStatus: action.payload.success,
      }

    case DELETESETUPAYURVEDICEXAMINATIONTONGUE:
      return {
        ...state,
        ayurvedicsetupTongueDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICEXAMINATIONPOOP:
      return {
        ...state,
        ayurvedicsetupPoopList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEXAMINATIONPOOP:
      return {
        ...state,
        ayurvedicsetupPoopSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONPOOP:
      return {
        ...state,
        ayurvedicsetupPoopUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICEXAMINATIONPOOP:
      return {
        ...state,
        ayurvedicsetupPoopDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICEXAMINATIONURINE:
      return {
        ...state,
        ayurvedicsetupUrineList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEXAMINATIONURINE:
      return {
        ...state,
        ayurvedicsetupUrineSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONURINE:
      return {
        ...state,
        ayurvedicsetupUrineUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICEXAMINATIONURINE:
      return {
        ...state,
        ayurvedicsetupUrineDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICEXAMINATIONWORD:
      return {
        ...state,
        ayurvedicsetupWordList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEXAMINATIONWORD:
      return {
        ...state,
        ayurvedicsetupWordSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONWORD:
      return {
        ...state,
        ayurvedicsetupWordUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICEXAMINATIONWORD:
      return {
        ...state,
        ayurvedicsetupWordDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICEXAMINATIONTOUCH:
      return {
        ...state,
        ayurvedicsetupTouchList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEXAMINATIONTOUCH:
      return {
        ...state,
        ayurvedicsetupTouchSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONTOUCH:
      return {
        ...state,
        ayurvedicsetupTouchUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICEXAMINATIONTOUCH:
      return {
        ...state,
        ayurvedicsetupTouchDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICEXAMINATIONEYE:
      return {
        ...state,
        ayurvedicsetupEyeList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEXAMINATIONEYE:
      return {
        ...state,
        ayurvedicsetupEyeSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONEYE:
      return {
        ...state,
        ayurvedicsetupEyeUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICEXAMINATIONEYE:
      return {
        ...state,
        ayurvedicsetupEyeDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICEXAMINATIONAKRITA:
      return {
        ...state,
        ayurvedicsetupAkritaList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEXAMINATIONAKRITA:
      return {
        ...state,
        ayurvedicsetupAkritaSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONAKRITA:
      return {
        ...state,
        ayurvedicsetupAkritaUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICEXAMINATIONAKRITA:
      return {
        ...state,
        ayurvedicsetupAkritaDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICEXAMINATIONNATUREPHYSICAL:
      return {
        ...state,
        ayurvedicsetupNaturePhysicalList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEXAMINATIONNATUREPHYSICAL:
      return {
        ...state,
        ayurvedicsetupNaturePhysicalSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONNATUREPHYSICAL:
      return {
        ...state,
        ayurvedicsetupNaturePhysicalUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICEXAMINATIONNATUREPHYSICAL:
      return {
        ...state,
        ayurvedicsetupNaturePhysicalDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICEXAMINATIONNATUREMENTAL:
      return {
        ...state,
        ayurvedicsetupNatureMentalList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEXAMINATIONNATUREMENTAL:
      return {
        ...state,
        ayurvedicsetupNatureMentalSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONNATUREMENTAL:
      return {
        ...state,
        ayurvedicsetupNatureMentalUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICEXAMINATIONNATUREMENTAL:
      return {
        ...state,
        ayurvedicsetupNatureMentalDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICEXAMINATIONSUBSTANCE:
      return {
        ...state,
        ayurvedicsetupexaminSubstanceList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEXAMINATIONSUBSTANCE:
      return {
        ...state,
        ayurvedicsetupexaminSubstanceSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONSUBSTANCE:
      return {
        ...state,
        ayurvedicsetupexaminSubstanceUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICEXAMINATIONSUBSTANCE:
      return {
        ...state,
        ayurvedicsetupexaminSubstanceDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICEXAMINATIONCOMPACTION:
      return {
        ...state,
        ayurvedicsetupexamincompactionList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEXAMINATIONCOMPACTION:
      return {
        ...state,
        ayurvedicsetupexamincompactionSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONCOMPACTION:
      return {
        ...state,
        ayurvedicsetupexamincompactionUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICEXAMINATIONCOMPACTION:
      return {
        ...state,
        ayurvedicsetupexamincompactionDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICEXAMINATIONPERCEPTION:
      return {
        ...state,
        ayurvedicsetupperceptionList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEXAMINATIONPERCEPTION:
      return {
        ...state,
        ayurvedicsetupperceptionSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONPERCEPTION:
      return {
        ...state,
        ayurvedicsetupperceptionUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICEXAMINATIONPERCEPTION:
      return {
        ...state,
        ayurvedicsetupperceptionDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICEXAMINATIONSUITABILITY:
      return {
        ...state,
        ayurvedicsetupSubstabilityList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEXAMINATIONSUITABILITY:
      return {
        ...state,
        ayurvedicsetupSubstabilitySaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONSUITABILITY:
      return {
        ...state,
        ayurvedicsetupSubstabilityUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICEXAMINATIONSUITABILITY:
      return {
        ...state,
        ayurvedicsetupSubstabilityDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICEXAMINATIONSUBSTANCESVATVAM:
      return {
        ...state,
        ayurvedicsetupSubstancesvatvamList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEXAMINATIONSUBSTANCESVATVAM:
      return {
        ...state,
        ayurvedicsetupSubstancesvatvamSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONSUBSTANCESVATVAM:
      return {
        ...state,
        ayurvedicsetupSubstancesvatvamUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICEXAMINATIONSUBSTANCESVATVAM:
      return {
        ...state,
        ayurvedicsetupSubstancesvatvamDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICEXAMINATIONDIETCARRYPOWER:
      return {
        ...state,
        ayurvedicsetupDietCarryPowerList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEXAMINATIONDIETCARRYPOWER:
      return {
        ...state,
        ayurvedicsetupDietCarryPowerSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONDIETCARRYPOWER:
      return {
        ...state,
        ayurvedicsetupDietCarryPowerUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICEXAMINATIONDIETCARRYPOWER:
      return {
        ...state,
        ayurvedicsetupDietCarryPowerDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICEXAMINATIONDIETBURNINGPOWER:
      return {
        ...state,
        ayurvedicsetupDietBurningPowerList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEXAMINATIONDIETBURNINGPOWER:
      return {
        ...state,
        ayurvedicsetupDietBurningPowerSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONDIETBURNINGPOWER:
      return {
        ...state,
        ayurvedicsetupDietBurningPowerUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICEXAMINATIONDIETBURNINGPOWER:
      return {
        ...state,
        ayurvedicsetupDietBurningPowerDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICEXAMINATIONEXERCIZEPOWER:
      return {
        ...state,
        ayurvedicsetupExcersizePowerList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEXAMINATIONEXERCIZEPOWER:
      return {
        ...state,
        ayurvedicsetupExcersizePowerSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONEXERCIZEPOWER:
      return {
        ...state,
        ayurvedicsetupExcersizePowerUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICEXAMINATIONEXERCIZEPOWER:
      return {
        ...state,
        ayurvedicsetupExcersizePowerDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICEXAMINATIONAGE:
      return {
        ...state,
        ayurvedicsetupAgeList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEXAMINATIONAGE:
      return {
        ...state,
        ayurvedicsetupAgeSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONAGE:
      return {
        ...state,
        ayurvedicsetupAgeUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICEXAMINATIONAGE:
      return {
        ...state,
        ayurvedicsetupAgeDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICEXAMINATIONPRANAVAHSROTAS:
      return {
        ...state,
        ayurvedicsetupPranavsrotasList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEXAMINATIONPRANAVAHSROTAS:
      return {
        ...state,
        ayurvedicsetupPranavsrotasSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONPRANAVAHSROTAS:
      return {
        ...state,
        ayurvedicsetupPranavsrotasUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICEXAMINATIONPRANAVAHSROTAS:
      return {
        ...state,
        ayurvedicsetupPranavsrotasDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICEXAMINATIONANNAVAHSROTAS:
      return {
        ...state,
        ayurvedicsetupAnnavahasrotasList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEXAMINATIONANNAVAHSROTAS:
      return {
        ...state,
        ayurvedicsetupAnnavahasrotasSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONANNAVAHSROTAS:
      return {
        ...state,
        ayurvedicsetupAnnavahasrotasUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICEXAMINATIONANNAVAHSROTAS:
      return {
        ...state,
        ayurvedicsetupAnnavahasrotasDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICEXAMINATIONUDAKAVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupUdakvahasrotasList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEXAMINATIONUDAKAVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupUdakvahasrotasSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONUDAKAVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupUdakvahasrotasUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICEXAMINATIONUDAKAVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupUdakvahasrotasDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICEXAMINATIONRASAVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupRasavahasrotasList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEXAMINATIONRASAVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupRasavahasrotasSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONRASAVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupRasavahasrotasUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICEXAMINATIONRASAVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupRasavahasrotasDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICEXAMINATIONRAKTAVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupRaktavahaList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEXAMINATIONRAKTAVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupRaktavahaSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONRAKTAVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupRaktavahaUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICEXAMINATIONRAKTAVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupRaktavahaDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICEXAMINATIONMAMSAVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupMamsavahaList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEXAMINATIONMAMSAVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupMamsavahaSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONMAMSAVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupMamsavahaUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICEXAMINATIONMAMSAVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupMamsavahaDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICEXAMINATIONMEDOVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupMedovahaList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEXAMINATIONMEDOVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupMedovahaSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONMEDOVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupMedovahaUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICEXAMINATIONMEDOVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupMedovahaDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICEXAMINATIONASTHIVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupAsthivahaList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEXAMINATIONASTHIVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupAsthivahaSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONASTHIVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupAsthivahaUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICEXAMINATIONASTHIVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupAsthivahaDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICEXAMINATIONMAJJAVHASROTAS:
      return {
        ...state,
        ayurvedicsetupMajjavahaList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEXAMINATIONMAJJAVHASROTAS:
      return {
        ...state,
        ayurvedicsetupMajjavahaSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONMAJJAVHASROTAS:
      return {
        ...state,
        ayurvedicsetupMajjavahaUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICEXAMINATIONMAJJAVHASROTAS:
      return {
        ...state,
        ayurvedicsetupMajjavahaDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICEXAMINATIONSUKRAVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupSukravahaList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEXAMINATIONSUKRAVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupSukravahaSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONSUKRAVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupSukravahaUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICEXAMINATIONSUKRAVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupSukravahaDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICEXAMINATIONMOOTRAVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupMootravahaList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEXAMINATIONMOOTRAVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupMootravahaSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONMOOTRAVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupMootravahaUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICEXAMINATIONMOOTRAVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupMootravahaDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICEXAMINATIONPUREESHVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupPureeshvahaList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEXAMINATIONPUREESHVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupPureeshvahaSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONPUREESHVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupPureeshvahaUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICEXAMINATIONPUREESHVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupPureeshvahaDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICEXAMINATIONSWEDAVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupSwedavahaList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEXAMINATIONSWEDAVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupSwedavahaSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONSWEDAVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupSwedavahaUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICEXAMINATIONSWEDAVAHASROTAS:
      return {
        ...state,
        ayurvedicsetupSwedavahaDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICEXAMINATIONTHEFAULT:
      return {
        ...state,
        ayurvedicsetupTheFaultList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEXAMINATIONTHEFAULT:
      return {
        ...state,
        ayurvedicsetupTheFaultSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONTHEFAULT:
      return {
        ...state,
        ayurvedicsetupTheFaultUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICEXAMINATIONTHEFAULT:
      return {
        ...state,
        ayurvedicsetupTheFaultDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICEXAMINATIONDUSHYA:
      return {
        ...state,
        ayurvedicsetupDushyaList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEXAMINATIONDUSHYA:
      return {
        ...state,
        ayurvedicsetupDushyaSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONDUSHYA:
      return {
        ...state,
        ayurvedicsetupDushyaUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICEXAMINATIONDUSHYA:
      return {
        ...state,
        ayurvedicsetupDushyaDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICEXAMINATIONFIRE:
      return {
        ...state,
        ayurvedicsetupFireList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEXAMINATIONFIRE:
      return {
        ...state,
        ayurvedicsetupFireSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONFIRE:
      return {
        ...state,
        ayurvedicsetupFireUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICEXAMINATIONFIRE:
      return {
        ...state,
        ayurvedicsetupFireDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICEXAMINATIONAMA:
      return {
        ...state,
        ayurvedicsetupAmaList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEXAMINATIONAMA:
      return {
        ...state,
        ayurvedicsetupAmaSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONAMA:
      return {
        ...state,
        ayurvedicsetupAmaUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICEXAMINATIONAMA:
      return {
        ...state,
        ayurvedicsetupAmaDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICEXAMINATIONSOURCES:
      return {
        ...state,
        ayurvedicsetupSourcesList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEXAMINATIONSOURCES:
      return {
        ...state,
        ayurvedicsetupSourcesSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONSOURCES:
      return {
        ...state,
        ayurvedicsetupSourcesUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICEXAMINATIONSOURCES:
      return {
        ...state,
        ayurvedicsetupSourcesDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICEXAMINATIONFACULTYSOURCESTYPE:
      return {
        ...state,
        ayurvedicsetupFacultysourcesList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEXAMINATIONFACULTYSOURCESTYPE:
      return {
        ...state,
        ayurvedicsetupFacultysourcesSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONFACULTYSOURCESTYPE:
      return {
        ...state,
        ayurvedicsetupFacultysourcesUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICEXAMINATIONFACULTYSOURCESTYPE:
      return {
        ...state,
        ayurvedicsetupFacultysourcesDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICEXAMINATIONPLACEOFORIGIN:
      return {
        ...state,
        ayurvedicsetupPlaceoforiginList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEXAMINATIONPLACEOFORIGIN:
      return {
        ...state,
        ayurvedicsetupPlaceoforiginSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEXAMINATIONPLACEOFORIGIN:
      return {
        ...state,
        ayurvedicsetupPlaceoforiginUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICEXAMINATIONPLACEOFORIGIN:
      return {
        ...state,
        ayurvedicsetupPlaceoforiginDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICDIGESTIVETRACT:
      return {
        ...state,
        ayurvedicsetupdigestivetractList: action.payload.data,
      }
    case CREATESETUPAYURVEDICDIGESTIVETRACT:
      return {
        ...state,
        ayurvedicsetupdigestivetractSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICDIGESTIVETRACT:
      return {
        ...state,
        ayurvedicsetupdigestivetractUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICDIGESTIVETRACT:
      return {
        ...state,
        ayurvedicsetupdigestivetractDeleteStatus: action.payload.success,
      }


    case GETSETUPAYURVEDICBOWEL:
      return {
        ...state,
        ayurvedicsetupBowelList: action.payload.data,
      }
    case CREATESETUPAYURVEDICBOWEL:
      return {
        ...state,
        ayurvedicsetupBowelSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICBOWEL:
      return {
        ...state,
        ayurvedicsetupBowelUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICBOWEL:
      return {
        ...state,
        ayurvedicsetupBowelDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICSLEEP:
      return {
        ...state,
        ayurvedicsetupSleepList: action.payload.data,
      }
    case CREATESETUPAYURVEDICSLEEP:
      return {
        ...state,
        ayurvedicsetupSleepSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICSLEEP:
      return {
        ...state,
        ayurvedicsetupSleepUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICSLEEP:
      return {
        ...state,
        ayurvedicsetupSleepDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICADDICTIONS:
      return {
        ...state,
        ayurvedicsetupAddictionsList: action.payload.data,
      }
    case CREATESETUPAYURVEDICADDICTIONS:
      return {
        ...state,
        ayurvedicsetupAddictionsSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICADDICTIONS:
      return {
        ...state,
        ayurvedicsetupAddictionsUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICADDICTIONS:
      return {
        ...state,
        ayurvedicsetupAddictionsDeleteStatus: action.payload.success,
      }


    case GETSETUPAYURVEDICHIGHRISK:
      return {
        ...state,
        ayurvedicsetupHightriskList: action.payload.data,
      }
    case CREATESETUPAYURVEDICHIGHRISK:
      return {
        ...state,
        ayurvedicsetupHightriskSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICHIGHRISK:
      return {
        ...state,
        ayurvedicsetupHightriskUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICHIGHRISK:
      return {
        ...state,
        ayurvedicsetupHightriskDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICPOSITIONOFWORK:
      return {
        ...state,
        ayurvedicsetupPositionofWorkList: action.payload.data,
      }
    case CREATESETUPAYURVEDICPOSITIONOFWORK:
      return {
        ...state,
        ayurvedicsetupPositionofWorkSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICPOSITIONOFWORK:
      return {
        ...state,
        ayurvedicsetupPositionofWorkUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICPOSITIONOFWORK:
      return {
        ...state,
        ayurvedicsetupPositionofWorkDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICNATUREOFWORK:
      return {
        ...state,
        ayurvedicsetupNatureofWorkList: action.payload.data,
      }
    case CREATESETUPAYURVEDICNATUREOFWORK:
      return {
        ...state,
        ayurvedicsetupNatureofWorkSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICNATUREOFWORK:
      return {
        ...state,
        ayurvedicsetupNatureofWorkUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICNATUREOFWORK:
      return {
        ...state,
        ayurvedicsetupNatureofWorkDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICDEPRESSION:
      return {
        ...state,
        ayurvedicsetupDepressionList: action.payload.data,
      }
    case CREATESETUPAYURVEDICDEPRESSION:
      return {
        ...state,
        ayurvedicsetupDepressionSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICDEPRESSION:
      return {
        ...state,
        ayurvedicsetupDepressionUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICDEPRESSION:
      return {
        ...state,
        ayurvedicsetupDepressionDeleteStatus: action.payload.success,
      }


    case GETSETUPAYURVEDICIRRITABILITY:
      return {
        ...state,
        ayurvedicsetupIrritabilityList: action.payload.data,
      }
    case CREATESETUPAYURVEDICIRRITABILITY:
      return {
        ...state,
        ayurvedicsetupIrritabilitySaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICIRRITABILITY:
      return {
        ...state,
        ayurvedicsetupIrritabilityUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICIRRITABILITY:
      return {
        ...state,
        ayurvedicsetupIrritabilityDeleteStatus: action.payload.success,
      }


    case GETSETUPAYURVEDICEUPHORIA:
      return {
        ...state,
        ayurvedicsetupEuphoriaList: action.payload.data,
      }
    case CREATESETUPAYURVEDICEUPHORIA:
      return {
        ...state,
        ayurvedicsetupEuphoriaSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICEUPHORIA:
      return {
        ...state,
        ayurvedicsetupEuphoriaUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICEUPHORIA:
      return {
        ...state,
        ayurvedicsetupEuphoriaDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICOBSESSION:
      return {
        ...state,
        ayurvedicsetupObsessionList: action.payload.data,
      }
    case CREATESETUPAYURVEDICOBSESSION:
      return {
        ...state,
        ayurvedicsetupObsessionSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICOBSESSION:
      return {
        ...state,
        ayurvedicsetupObsessionUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICOBSESSION:
      return {
        ...state,
        ayurvedicsetupObsessionDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICNEUROSIS:
      return {
        ...state,
        ayurvedicsetupNeurosisList: action.payload.data,
      }
    case CREATESETUPAYURVEDICNEUROSIS:
      return {
        ...state,
        ayurvedicsetupNeurosisSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICNEUROSIS:
      return {
        ...state,
        ayurvedicsetupNeurosisUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICNEUROSIS:
      return {
        ...state,
        ayurvedicsetupNeurosisDeleteStatus: action.payload.success,
      }

    case GETSETUPAYURVEDICDEPERSONALIZATION:
      return {
        ...state,
        ayurvedicsetupDepersonalizationList: action.payload.data,
      }
    case CREATESETUPAYURVEDICDEPERSONALIZATION:
      return {
        ...state,
        ayurvedicsetupDepersonalizationSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICDEPERSONALIZATION:
      return {
        ...state,
        ayurvedicsetupDepersonalizationUpdateStatus: action.payload.success,
      }
    case DELETESETUPAYURVEDICDEPERSONALIZATION:
      return {
        ...state,
        ayurvedicsetupDepersonalizationDeleteStatus: action.payload.success,
      }


    case GETAYURVEDICOPDCHILDHOODILLNESS:
      return {
        ...state,
        ayurvedicsetupChildillnessList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDCHILDHOODILLNESS:
      return {
        ...state,
        ayurvedicsetupChildillnessSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDCHILDHOODILLNESS:
      return {
        ...state,
        ayurvedicsetupChildillnessUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDCHILDHOODILLNESS:
      return {
        ...state,
        ayurvedicsetupChildillnessDeleteStatus: action.payload.success,
      }

    case GETAYURVEDICOPDADULTILLNESS:
      return {
        ...state,
        ayurvedicsetupAdultillnessList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDADULTILLNESS:
      return {
        ...state,
        ayurvedicsetupAdultillnessSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDADULTILLNESS:
      return {
        ...state,
        ayurvedicsetupAdultillnessUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDADULTILLNESS:
      return {
        ...state,
        ayurvedicsetupAdultillnessDeleteStatus: action.payload.success,
      }

    default:
      return state;
  }
}
